// BookTickets/stages/DateAndTime/lib/dateAndTime.ts

import { startOfDay, isPast } from 'date-fns'

export const STORAGE_KEY_DATE = 'book.date'

export function isSpecialDate(d: Date): boolean {
  // 2023-11-01 (months are 0-based; 10 = November)
  return d.getFullYear() === 2023 && d.getMonth() === 10 && d.getDate() === 1
}

export function parseQueryDate(raw: string | null): Date | null {
  if (!raw) return null
  const d = new Date(raw)
  return Number.isNaN(d.getTime()) ? null : d
}

export function clampToTodayIfPast(d: Date): Date {
  return isPast(startOfDay(d)) ? new Date() : d
}

export function resolveCalendarLocale(locale: string): string {
  const map: Record<string, string> = { en: 'en', pt: 'pt', fr: 'fr', es: 'es' }
  return map[locale] ?? 'en'
}
